import React, { useEffect, useState } from 'react';
import { selectFilter, textFilter } from 'react-bootstrap-table2-filter';
import { VscNewFile, VscRefresh, VscSearch } from 'react-icons/vsc';
import { useDispatch, useSelector } from 'react-redux';
import AttenteRequete from '../../../hoc/AttenteRequete/AttenteRequete';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import * as privilege from '../../../ressources/glossaires/glossaire_privileges';
import * as requestType from '../../../ressources/glossaires/glossaire_requetes';
import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import * as glossaire_type_de_graphe from '../../../ressources/glossaires/glossaire_type_de_graphe';
import * as actions from '../../../services/actions';
import Bouton from '../../UI/Bouton/Bouton';
import Tableau from '../../UI/tableau/Tableau';
import S from './TableauGraphe.module.scss';

const TableauGraphe = ({ creer, projetSelectione }) => {
  const dispatch = useDispatch();
  const listeGraphes = useSelector((state) => state.graphe.graphs_list);
  const filtre_projects_list_id = useSelector(
    (state) => state.authentifie.filtre_projects_list_id
  );
  const project_id_url = useSelector(
    (state) => state.interfaceClient.project_id_url
  );
  const interfaceAdmin = useSelector(
    (state) => state.authentifie.interfaceAdmin
  );

  const [iconeCreer] = useState(<VscNewFile size={15} />);
  const [columns, setColumns] = useState([
    {
      dataField: 'graph_id',
      text: [
        checkMot('id'),
        <Bouton
          key="graph_id"
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('graph_id', checkMot('graph_id'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
      hidden: !interfaceAdmin,
    },
    {
      dataField: 'project_id',
      text: [
        checkMot('projet'),
        <Bouton
          key="project_id"
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('project_id', checkMot('project_id'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
      hidden: !interfaceAdmin,
    },
    {
      dataField: 'graph_name',
      text: [
        checkMot('nom'),
        <Bouton
          key="graph_name"
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('graph_name', checkMot('graph_name'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
    },
    {
      dataField: 'private',
      text: checkMot('propriete') + ' ',
      sort: true,
      formatter: (cell) => {
        switch (parseInt(cell)) {
          case 1:
            return checkMot('prive');
          case 0:
            return checkMot('public');
          default:
            return checkMot(cell);
        }
      },
      filter: selectFilter({
        options: {
          1: checkMot('prive'),
          0: checkMot('public'),
        },
        placeholder: checkMot('selectionner'),
      }),
    },
    {
      dataField: 'graph_type_id',
      text: checkMot('type_de_graphe') + ' ',
      sort: true,
      formatter: (cell) =>
        checkMot(
          Object.keys(glossaire_type_de_graphe).find(
            (key) => glossaire_type_de_graphe[key] === parseInt(cell)
          )
        ),
      filter: selectFilter({
        options: Object.fromEntries(
          Object.keys(glossaire_type_de_graphe)
            .map((objKey) => [
              glossaire_type_de_graphe[objKey],
              checkMot(objKey),
            ])
            .slice(1)
        ),
        placeholder: checkMot('selectionner'),
      }),
    },
  ]);

  const [selectRow] = useState({
    mode: 'radio',
    clickToSelect: true,
    hideSelectAll: true,
    hideSelectColumn: true,
    style: () => ({
      background: '#eeb214',
      color: 'black',
    }),
    onSelect: (row) => projetSelectione(row),
  });

  useEffect(() => {
    if (!isNaN(project_id_url) && project_id_url !== '') {
      dispatch(actions.reqRecupererListeGraphes([parseInt(project_id_url)]));
    } else if (filtre_projects_list_id.length > 0) {
      dispatch(actions.reqRecupererListeGraphes(filtre_projects_list_id));
    }
  }, [dispatch, project_id_url, filtre_projects_list_id]);

  const afficherFiltre = (dataField, placeholder) => {
    const newCol = columns.map((col) => {
      if (col.dataField === dataField) {
        return {
          ...col,
          filter: textFilter({
            placeholder: placeholder,
          }),
        };
      }
      return col;
    });
    setColumns(newCol);
  };

  const rafraichirTableau = () => {
    if (!isNaN(project_id_url) && project_id_url !== '') {
      dispatch(actions.reqRecupererListeGraphes([parseInt(project_id_url)]));
    } else {
      dispatch(actions.reqRecupererListeGraphes(filtre_projects_list_id));
    }
  };

  const listeCleACache =
    listeGraphes?.reduce((acc, graph) => {
      if (interfaceAdmin) {
        if (!filtre_projects_list_id.includes(parseInt(graph.project_id))) {
          acc.push(graph.graph_id);
        }
      } else {
        if (parseInt(graph.project_id) !== parseInt(project_id_url)) {
          acc.push(graph.graph_id);
        }
      }
      return acc;
    }, []) || [];

  return (
    <>
      <Tableau
        cleLigne={'graph_id'}
        privilegeCreer={privilege.creer_des_projets}
        creer={creer}
        iconeCreer={iconeCreer}
        lignesCache={listeCleACache}
        donnees={listeGraphes}
        colonnes={columns}
        selectionnerLignes={selectRow}
      >
        <AttenteRequete
          request_type={requestType.recuperation_de_la_liste_des_graphes}
          str={checkMot('maj_graphes_en_cour')}
        >
          <Bouton
            hoverText={checkMot('refresh')}
            ajoutClass={S.btn}
            type={type_btn.outil}
            rond={true}
            cliquer={rafraichirTableau}
          >
            <VscRefresh size={15} />
          </Bouton>
        </AttenteRequete>
      </Tableau>
    </>
  );
};

export default TableauGraphe;
